import request from '@/utils/request'
import Vue from 'vue'



//  查询交易列表分页
export function getTransactionListPage(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/transactionMatchUp/getTransactionListPage',
        params
    })
}

// 查询撮合列表分页
// export function getMatchUpListPage(data) {
//     return request({
//         method: 'POST',
//         url: Vue.prototype.baseURL + '/product/transactionMatchUp/getMatchUpListPageByParam',
//         data
//     })
// }
// 查询撮合列表分页--new
export function getMatchUpListPage(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/transactionMatchUp/getMatchUpListPage',
        params
    })
}
//  交易类型
export function selectListByType(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/sys-dict-code/selectListByType',
        params
    })
}

//  撮合筛选
export function getMatchUpClassification(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/transactionMatchUp/getMatchUpClassification',
        params
    })
}

// 类型列表
export function getTypeList(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/transactionMatchUp/getTypeList',
        params
    })
}



// 新增交易
export function addTransaction(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/transactionMatchUp/addTransaction',
        data
    })
}

// 省市区
export function selectListRegion(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/services/fs-region/selectList',
        data
    })
}

// 产品分类
export function productTypeSelectList(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/produce/fs-produce-type/selectList',
        data
    })
}

// 产品名称列表
export function productVarietiesSelectList(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/produce/fs-product-varieties/selectList',
        data
    })
}
// 产品品种列表
export function productClassifySelectList(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/produce/fs-product-classify/selectList',
        data
    })
}

// 交易产品图片上传
export function transactionsReleaseUploadImg(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/brand/file/upload?folder=transactions',
        data
    })
}
// 撮合产品图片上传
export function matchUpReleaseUploadImg(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/brand/file/upload?folder=matchUp',
        data
    })
}


// 新增撮合
export function addMatchUp(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/transactionMatchUp/addMatchUp',
        data
    })
}

// 交易详情
export function transactionGetById(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/transactionMatchUp/getTransactionDetails',
        params
    })
}

// 撮合详情
export function matchUpGetById(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/transactionMatchUp/getMatchUpDetails',
        params
    })
}